'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageViewController = function () {
  function MessageViewController(authService, messagingService, loadingService, $stateParams, $state, pushService, enquiryService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MessageViewController);
    this.authService = authService;
    this.messagingService = messagingService;
    this.loadingService = loadingService;
    this.$state = $state;
    this.pushService = pushService;
    this.enquiryService = enquiryService;

    this.loadMessage($stateParams.messageId);
  }

  (0, _createClass3.default)(MessageViewController, [{
    key: 'loadMessage',
    value: function loadMessage(messageId) {
      var ctrl = this;

      ctrl.loadingService.showLoading('messageView', 'Loading Message ...');

      ctrl.messagingService.getMessage(messageId).then(function (response) {
        ctrl.message = response.data;
        ctrl.messageType = JSON.parse(ctrl.message.body).messageType;
        ctrl.messageBody = JSON.parse(ctrl.message.body).msg;
      }).catch(function (err) {}).finally(function () {
        ctrl.loadingService.hideLoading('messageView');
      });
    }
  }, {
    key: 'gotoEnquiry',
    value: function gotoEnquiry() {
      this.$state.go('enquiryEdit', {
        enquiryId: JSON.parse(this.message.body).enquiryId
      });
    }
  }, {
    key: 'gotoFinance',
    value: function gotoFinance() {
      this.$state.go('financeEdit', {
        financeId: JSON.parse(this.message.body).financeId
      });
    }
  }, {
    key: 'decline',
    value: function decline() {
      this.pushService.messageHub.enquiryDeclined(JSON.parse(this.message.body).enquiryId, JSON.parse(this.message.body).senderId);
    }
  }, {
    key: 'accept',
    value: function accept() {
      var _this = this;

      this.enquiryService.updateOwner(JSON.parse(this.message.body).enquiryId, this.authService.authData.userId).then(function () {
        _this.pushService.messageHub.enquiryAccepted(JSON.parse(_this.message.body).enquiryId, JSON.parse(_this.message.body).senderId);
        _this.$state.go('enquiryEdit', { enquiryId: JSON.parse(_this.message.body).enquiryId });
      });
    }
  }]);
  return MessageViewController;
}();

exports.default = MessageViewController;


// WEBPACK FOOTER //
// ./client/app/components/messaging/messageView/messageView.controller.js